(function () {
  'use strict';


  function breadcrumb (breadcrumbFactory, $state, $location) {
    function link (scope) {
      function triggerState (state) {
        $state.go(state);
      }

      function triggerLocation (url) {
        $location.path(url);
      }

      function goTo (page) {
        const action = {
          0: triggerState,
          1: triggerLocation
        };

        action[Number(!page.state)](page.url || page.state);
      }

      scope.getBreadcrumb = breadcrumbFactory.getBreadcrumbs;
      scope.goTo = goTo;
    }

    return {
      templateUrl: 'components/shared/breadcrumb/breadcrumb.html',
      link: link
    };
  }

  angular.module('web2print.shared')
    .directive('breadcrumb', breadcrumb);

  breadcrumb.$inject = ['breadcrumbFactory', '$state', '$location'];
})();
